// extracted by mini-css-extract-plugin
export var actionButton = "_ns-0";
export var actionMenuContainer = "_ns-i";
export var bubble = "_ns-2";
export var bubbleActionMenu = "_ns-j";
export var bubbleContext = "_ns-6";
export var bubbleItems = "_ns-7";
export var customer = "_ns-3";
export var divider = "_ns-8";
export var fileList = "_ns-9";
export var hiddenComment = "_ns-o";
export var infoAbove = "_ns-a";
export var internal = "_ns-4";
export var lightActionButton = "_ns-1";
export var link = "_ns-b";
export var merchant = "_ns-5";
export var message = "_ns-c";
export var profilePicture = "_ns-e";
export var quillToolbarContainer = "_ns-f";
export var senderDate = "_ns-g";
export var senderDateCustomer = "_ns-h";
export var senderName = "_ns-d";
export var time = "_ns-k";
export var uploadedImage = "_ns-l";
export var username = "_ns-m";
export var xsmall = "_ns-n";